export const wrapper = ({ theme: { dimensions } }) => ({
    display: 'grid',
    gridTemplateColumns: '360px 360px',
    gridColumnGap: '16px',
    gridRowGap: dimensions.inputRowGap,
});
